import { toDateString } from "./toDateString";
export function toDateRangeString(value, formatString) {
    var _toDateString, _toDateString1;
    return "".concat((_toDateString = toDateString(value === null || value === void 0 ? void 0 : value.from, formatString)) !== null && _toDateString !== void 0 ? _toDateString : "-", " ~ ").concat((_toDateString1 = toDateString(value === null || value === void 0 ? void 0 : value.to, formatString)) !== null && _toDateString1 !== void 0 ? _toDateString1 : "-");
}
